import { Component, HostListener, OnInit } from '@angular/core';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { VersionController } from '@commoncore/controller/VersionController';
import { GlobalService } from '@commoncore/services/global.service';
import { VersionModuleType } from '@commoncore/services/universal.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { DeleteVersionComponent } from '../delete-version/delete-version.component';

@Component({
  standalone:true,
  selector: 'common-manage-version',
  templateUrl: './manage-version.component.html',
  styleUrls: ['./manage-version.component.scss'],
  imports:[DeleteVersionComponent,DependenciesModule]
})
export class ManageVersionComponent implements OnInit {
  public universalService:any;
  public showManageVersionPanel:boolean = false;
  versionController: any;
  versionImplementation: any;
  listService: any;
  selectedVersion:any;
  showDeleteConfirmation:any;
  requiredMetadataForCreatingAPIEndpoints:any;
  folderService:any;
  http: any;
  tabDetails: any = [];
  contextMenu: any = [];
  selectedObject : any = undefined;
  cleverTapEventsService:any;

  constructor(public globalService:GlobalService) {
    this.setEnvObjects(globalService);
    this.fetchJSONContents();
   }

   @HostListener('document:keydown', ['$event'])
   onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.showManageVersionPanel && !this.showDeleteConfirmation) {
      this.closeManageVersionPopup()
    }
  }

  ngOnInit(): void {
    this.versionController = VersionController.getInstance(this.globalService);
    this.versionImplementation = this.versionController.versionImplementation;
    AppEvents.optionSelected.subscribe(event => {
        if(event["manageVersions"]){
          this.showManageVersionPanel = true;
          this.universalService.popUpToBeOpened = "dummy"
          this.universalService.disableModalBackdrop();
          this.universalService.showModalBackdrop();
          this.fetchVersionListForSelectedFile();
        }else if (event["closeAll"]){
          this.showManageVersionPanel = false;
        }
    })
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.folderService = globalService.getFolderServiceRef();
    this.http = globalService.getHttpClientRef();
    this.cleverTapEventsService =  globalService.getCleverTapEventsvc();
  }

  async fetchVersionListForSelectedFile(){
    this.versionImplementation.toggleLoader(true)
    this.requiredMetadataForCreatingAPIEndpoints = this.getModuleTypeAndRequiredMetadata();
    var result = await this.versionController.getVersionsForFile(this.requiredMetadataForCreatingAPIEndpoints["moduleType"],this.requiredMetadataForCreatingAPIEndpoints);
  }


  cancelDelete(event){
    this.showDeleteConfirmation = false;
    this.universalService.showModalBackdrop();
  }

  closeManageVersionPopup(){
    this.showDeleteConfirmation = false;
    this.listService.deSelectAll()
  }

  async confirmDelete(event){
    this.showDeleteConfirmation = false;
    this.versionImplementation.toggleLoader(true)
    var result = await this.versionController.deleteSelectedVersion(this.requiredMetadataForCreatingAPIEndpoints["moduleType"],this.requiredMetadataForCreatingAPIEndpoints,this.selectedVersion);
    if(result && result["deleted version"]){
      var msg = TOAST["DELETE_VERSION_SUCCESS"].replace("fileName",this.universalService.selectedFile.objectName);
      msg = msg.replace("displayVersion",this.selectedVersion["displayVersion"])
      this.universalService.showToast(msg,"success");
      if(this.universalService.showPreview && !this.universalService.selectedFile["showLatestVersion"] && this.selectedVersion["version"] == this.selectedVersion["version"]){
        var obj = this.universalService.selectedFile["FullObject"] ? this.universalService.selectedFile["FullObject"] : this.universalService.selectedFile;
        this.universalService.openPreview(obj,true);
        AppEvents.objectPreview.next({openPreview:true});
        this.universalService.showModalBackdrop();
      }
    }else{
      var msg = TOAST["DELETE_VERSION_FAILURE"].replace("fileName",this.universalService.selectedFile.objectName);
      msg = msg.replace("displayVersion",this.selectedVersion["displayVersion"])
      this.universalService.showToast(msg,"error");
    }
  }

  showDeleteConfirmationDialog(){
    this.showDeleteConfirmation = true;
  }

  async restoreVersion(){
    this.versionImplementation.toggleLoader(true)
    var result = await this.versionController.restoreSelectedVersion(this.requiredMetadataForCreatingAPIEndpoints["moduleType"],this.requiredMetadataForCreatingAPIEndpoints,this.selectedVersion);
    if(result && result["restored version"]){
      var msg = TOAST["RESTORE_VERSION_SUCCESS"].replace("fileName",this.universalService.selectedFile.objectName);
      msg = msg.replace("displayVersion",this.selectedVersion["displayVersion"])
      this.universalService.showToast(msg,"success");
    }else{
      var msg = TOAST["RESTORE_VERSION_FAILURE"].replace("fileName",this.universalService.selectedFile.objectName);
      msg = msg.replace("displayVersion",this.selectedVersion["displayVersion"])
      this.universalService.showToast(msg,"error");
    }
  }


  decideAction(action){
    switch(action){
      case 'restore':
        this.cleverTapEventsService.manageVerRestoreClicked();
        this.restoreVersion();
        break;
      case 'deleteObject':
        this.cleverTapEventsService.manageVerDeleteForeverClicked();
        this.showDeleteConfirmationDialog();
        break;
      case 'downloadItems':
        this.cleverTapEventsService.manageVerDownloadClicked();
        var obj = this.universalService.selectedFile["FullObject"] ? this.universalService.selectedFile["FullObject"] : this.universalService.selectedFile;
        var queryParams = new URL(obj["url"]);
        var search_params = queryParams.searchParams;
        if(this.selectedVersion["isCurrentVersion"]){
          search_params.delete("version");
          queryParams.search = search_params.toString();
          obj["url"] = queryParams.toString();
        }else if(obj["url"].includes("version=")){
          search_params.set("version", this.selectedVersion["version"]);
          queryParams.search = search_params.toString();
          obj["url"] = queryParams.toString();
        }else{
          obj["url"] =  (obj["url"].includes('?') ? obj["url"] + '&': obj["url"] + '?') + "version=" + this.selectedVersion["version"];
        }     
        this.universalService.selectedNodes = [obj];
        AppEvents.globalObservable.next({"downloadItems": true,"files":this.universalService.selectedNodes});
        break;
      default:
        console.log("action not supported on version",action);
    }
  }

  getModuleTypeAndRequiredMetadata(){
    this.selectedObject = this.universalService.selectedFile["FullObject"] ? this.universalService.selectedFile["FullObject"] : this.universalService.selectedFile; 
    if(this.universalService.showPreview && this.selectedObject?.previewFromUpload){
      return this.getModuleTypeAndRequiredMetadataFromUpload();
    }
    var tab = this.universalService.selectedTab;
    if((tab == "SearchResults" || tab == "AISearchResults" || tab == "TeamFolderSearchResults" || tab == "SearchResultsDetailed") && this.universalService.searchType == 'global' || this.universalService.selectedTab == 'Home'){
      tab = "My Files";
    } else if((tab == "SearchResults" || tab == "AISearch Results" || tab == "TeamFolderSearch Results" || tab == "SearchResultsDetailed") && this.universalService.searchType == 'teamfolder'){
      tab = "teamfolders";
    }
    var obj = {};
    switch(tab){
      case "My Files":
        obj["objectKey"] = this.selectedObject["objectKey"];
        obj["moduleType"] = VersionModuleType.MY_FILES;
        return obj
      case "Favorites":
        obj["objectKey"] = this.selectedObject["objectKey"];
        obj["moduleType"] = VersionModuleType.MY_FILES;
        return obj
      case "Album Details":
        obj["objectKey"] = this.selectedObject["objectKey"];
        obj["moduleType"] = VersionModuleType.ALBUMS;
        obj["boardKey"] = this.universalService.currentAlbum["boardKey"];
        return obj
      case "Shared Files":
        obj["objectKey"] = this.selectedObject["objectKey"];
        obj["moduleType"] = VersionModuleType.SHARED_FILES;
        obj["shareKey"] = this.selectedObject["shareKey"];
        return obj
      case "teamfolders":
        obj["objectKey"] = this.selectedObject["objectKey"];
        obj["moduleType"] = VersionModuleType.TEAM_FOLDERS;
        obj["tfKey"] = this.universalService.currentTeamFolder["tfKey"];
        return obj
    }
  }

  getModuleTypeAndRequiredMetadataFromUpload(){
    this.selectedObject = this.universalService.selectedFile["FullObject"] ? this.universalService.selectedFile["FullObject"] : this.universalService.selectedFile; 
    let uploadInitiatedModule = this.selectedObject["uploadInitiatedModule"];
    var obj = {};
    switch(uploadInitiatedModule){
      case "Album Details":
        obj["objectKey"] = this.selectedObject["objectKey"];
        obj["moduleType"] = VersionModuleType.ALBUMS;
        obj["boardKey"] = this.selectedObject["boardKey"];
        return obj
      case "sharedFiles":
        obj["objectKey"] = this.selectedObject["objectKey"];
        obj["moduleType"] = VersionModuleType.SHARED_FILES;
        obj["shareKey"] = this.selectedObject["shareKey"];
        return obj
      case "teamfolders":
        obj["objectKey"] = this.selectedObject["objectKey"];
        obj["moduleType"] = VersionModuleType.TEAM_FOLDERS;
        obj["tfKey"] = this.selectedObject["tfKey"];
        return obj
      default:
          obj["objectKey"] = this.selectedObject["objectKey"];
          obj["moduleType"] = VersionModuleType.MY_FILES;
          return obj
    }
  }

  decideOptionsListBasedOnAccessRights(version){
    var moduleType = this.requiredMetadataForCreatingAPIEndpoints["moduleType"];
    this.selectedVersion = version;
    switch(moduleType){
      case VersionModuleType.SHARED_FILES:
        if(this.universalService.selectedFile["editAccess"] && !this.selectedVersion["isCurrentVersion"]){
          this.getOptionsForEditAccess();
        }else{
          this.getOptionsForReadAccess();
        }
        break;
      case VersionModuleType.TEAM_FOLDERS:
        if(this.universalService.selectedFile["roleCode"] != 'V' && !this.selectedVersion["isCurrentVersion"]){
          this.getOptionsForEditAccess();
        }else{
          this.getOptionsForReadAccess();
        }
        break;
      default:
        if(!this.selectedVersion["isCurrentVersion"]){
          this.getOptionsForEditAccess();
        }else{
          this.getOptionsForReadAccess();
        }
    }
  }

  getOptionsForEditAccess(){
    this.contextMenu = this.tabDetails["EDIT_ACCESS"];
  }

  getOptionsForReadAccess(){
    this.contextMenu = this.tabDetails["READ_ACCESS"];
  }

  fetchJSONContents(){
    var self = this;
    this.http.get(ENV_CONFIG.jsonUrls.versionMenu).subscribe(
      suc=>{
        self.tabDetails = suc;
      }
    )
  }

  openPreviewOfCurrentVersion(version){
    let target = $(event.target).closest('.NeueMore_Options');
    let dropdown = $(event.target).closest('.dropdown');
    if(target[0] != undefined || dropdown[0] != undefined) return;
    var obj = this.universalService.selectedFile["FullObject"] ? this.universalService.selectedFile["FullObject"] : this.universalService.selectedFile;
    obj["version"] = version["version"];
    this.showManageVersionPanel = false;
    this.universalService.openPreview(obj,version["isCurrentVersion"] ? true : false);
    if(this.universalService.showPreview){
      AppEvents.objectPreview.next({openPreview:true});
    }
  }


  toggleMoreOptions(version){
    this.decideOptionsListBasedOnAccessRights(version)
  }


}
